import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'section-f',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-f.component.html',
  styleUrl: './section-f.component.css'
})
export class SectionFComponent implements OnInit, OnChanges {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection8 = new EventEmitter<any>();

  yesNo = EYesNo;
  sectionFForm: FormGroup = new FormGroup([]);

  radioQuestions = [   
    {
      id: 'violent_behavior_victim',
      questionText: 'Victim of violent behavior? *',
      formControlName: 'violent_behavior_victim',
      infoFormControlName: 'violent_behavior_victim_information',
      label: 'Please explain: *'
    },
    {
      id: 'violent_behavior_perpetrator',
      questionText: 'Perpetrator of violent behavior? *',
      formControlName: 'violent_behavior_perpetrator',
      infoFormControlName: 'violent_behavior_perpetrator_information',
      label: 'Please explain: *'
    },
    {
      id: 'violent_behavior_witness',
      questionText: 'Witness of violent behavior? *',
      formControlName: 'violent_behavior_witness',
      infoFormControlName: 'violent_behavior_witness_information',
      label: 'Please explain: *'
    },
    {
      id: 'violent_behavior_criminal',
      questionText: 'Criminal history of violent behavior? *',
      formControlName: 'violent_behavior_criminal',
      infoFormControlName: 'violent_behavior_criminal_information',
      label: 'Please explain: *'
    },
    {
      id: 'violence_exposure',
      questionText: 'Exposed to violence? *',
      formControlName: 'violence_exposure',
      infoFormControlName: 'violence_exposure_information',
      label: 'Please explain: *'
    },
    {
      id: 'family_violence',
      questionText: 'Family history of violence? *',
      formControlName: 'family_violence',
      infoFormControlName: 'family_violence_information',
      label: 'Please explain: *'
    },
    {
      id: 'acceptable_violence',
      questionText: 'Does the student have a history of using violence as an acceptable or desirable way to solve problems? *',
      formControlName: 'acceptable_violence',
      infoFormControlName: 'acceptable_violence_information',
      label: 'Please explain: *'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};

    this.radioQuestions.forEach(question => {
      group[question.formControlName] = new FormControl(String(this.fullTeamAssessmentData?.[question.formControlName]) || this.yesNo.No, Validators.required);
      group[question.infoFormControlName] = new FormControl({ value: this.fullTeamAssessmentData?.[question.infoFormControlName] || '', disabled: this.fullTeamAssessmentData?.[question.infoFormControlName] ? false: true });
    });
    group['f_additional_info'] = new FormControl(String(this.fullTeamAssessmentData?.f_additional_info) || this.yesNo.No, Validators.required);    

    this.sectionFForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.sectionFForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.sectionFForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveSectionF(): void {
    if (this.sectionFForm.valid) {
      this.onSaveSection8.emit(this.sectionFForm.value);
    }
  }

}
